import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from "../../shared/common.service";
import { HttpParams } from '@angular/common/http';

interface Access {
  id: string;
  email: string;
  subscription_type: string;
  duration: string;
  duration_months?: number;
  status: string;
}

@Component({
  selector: 'app-access-list',
  templateUrl: './access-list.component.html',
  styleUrls: ['./access-list.component.scss']
})
export class AccessListComponent implements OnInit {
  access: Access[] = [];
  filteredData: Access[] = [];
  paginatedData: Access[] = [];
  searchText = '';
  subscriptionFilter = '';
  statusFilter = '';
  totalPages: number[] = [];

  currentPage = 1;
  pageSize = 10;  
  pages = 0; 
  totalAccess = 0; 
  data: Access[] = [];

  selectedAccessId: string = '';

  authToken: string | null=null;
  previousPage: number;

  
  pageNumbersToShow: number = 4; // Number of page buttons to display
  pageRange: number[] = []; // Array to hold the page range for display
  maxPagesToShow: number = 4; // Show 4 pages at a time


  constructor(private apiService: ApiService, private router: Router,private cookieService: CookieService, private commonService: CommonService,
    private route: ActivatedRoute 
  ) {}

  ngOnInit(): void {
    let userData = this.commonService.getUserData(); 

    if (userData == null || userData.designation != 'Admin') {
      this.commonService.navigateTo("/");
    }
    // this.loadAccess();
    // this.loadAccess(this.currentPage);
    this.authToken = this.cookieService.get('token');
    console.log('Retrieved Token:', this.authToken);


  let params = new HttpParams();
  this.route.queryParams.subscribe(params => {
    // Set current filters and page from query params
    this.currentPage = +params['page'] || 1;
    this.searchText = params['searchText'] || '';
    this.subscriptionFilter = params['subscriptionFilter'] || '';
    this.statusFilter = params['statusFilter'] || '';
    this.loadAccess();
});


this.searchAccess();

  }


/*
searchAccess(): void {
  this.updateQueryParams();
  this.apiService.getUserList(this.currentPage, this.pageSize, this.searchText, this.searchSite, this.designationFilter, this.statusFilter).subscribe(
    (response: any) => {
      this.access = response.data;
      this.pages = response.totalPages;
      this.totalAccess = response.totalUsers;
    },
    (error) => {
      console.error('Error fetching access', error);
    }
  );
}
*/
searchAccess(): void {
  this.updateQueryParams();
  this.applyFilters();
}

loading: boolean = false;
loadAccess(): void {
  this.loading = true;

  this.apiService.getAccessList().subscribe(
    (response: any) => {
      this.access = response.data || response;
      this.data = response.data || response;

      // Process access data
      this.access = this.data.map((access: any) => ({
        ...access,
        status: this.extractStatus(access.status)  // Convert binary to string
      }));

      // Initialize filtered data with all access (no filtering on load)
      this.filteredData = [...this.access];

      this.pages = Math.ceil(this.filteredData.length / this.pageSize);
      this.totalAccess = this.filteredData.length;

      // Update the page range for pagination display
      this.updatePageRange();
      this.updatePaginatedData();
      this.loading = false;
    },
    error => {
      console.error('Error fetching access', error);
      this.loading = false;
    }
  );
}



updateQueryParams(): void {
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: {
      page: this.currentPage,
      searchText: this.searchText,
      subscriptionFilter: this.subscriptionFilter,
      statusFilter: this.statusFilter
    },
    queryParamsHandling: 'merge'
  });
}

// Update the visible page range based on the current page
updatePageRange(): void {
  this.pageRange = []; // Clear the existing page range

  const startPage = Math.floor((this.currentPage - 1) / this.maxPagesToShow) * this.maxPagesToShow + 1;
  const endPage = Math.min(startPage + this.maxPagesToShow - 1, this.pages);

  for (let i = startPage; i <= endPage; i++) {
    this.pageRange.push(i);
  }
}

nextPage(): void {
  if (this.currentPage < this.pages) {
    this.currentPage++;
    this.updatePageRange();
    this.updatePaginatedData();
  }
}

prevPage(): void {
  if (this.currentPage > 1) {
    this.currentPage--;
    this.updatePageRange();
    this.updatePaginatedData();
  }
}

goToPage(pageIndex: number): void {
  if (pageIndex > 0 && pageIndex <= this.pages) {
    this.currentPage = pageIndex;
    this.updatePageRange();
    this.updatePaginatedData();
  }
}



  

  extractStatus(status: string): string {
    if (!status) return 'Unknown';
    const statusLower = status.toLowerCase();
    if (statusLower === 'active') return 'Active';
    if (statusLower === 'inactive') return 'Inactive';
    return status; // Return original if not recognized
  }
  

  applyFilters(): void {
    if (!this.access || this.access.length === 0) {
      this.filteredData = [];
      return;
    }

    this.filteredData = this.access.filter(access => {
      // Filter by email
      const matchesSearchText = !this.searchText || 
        access.email?.toLowerCase().includes(this.searchText.toLowerCase());

      // Filter by subscription type
      const matchesSubscription = !this.subscriptionFilter || 
        access.subscription_type === this.subscriptionFilter;

      // Filter by status (case-insensitive)
      const matchesStatus = !this.statusFilter || 
        access.status?.toLowerCase() === this.statusFilter.toLowerCase();

      return matchesSearchText && matchesSubscription && matchesStatus;
    });

    // Update pagination
    this.pages = Math.ceil(this.filteredData.length / this.pageSize);
    this.totalAccess = this.filteredData.length;
    this.currentPage = 1; // Reset to first page when filtering
    this.updatePageRange();
    this.updatePaginatedData();
  }
  
  calculateTotalPages(): void {
    const pageCount = Math.ceil(this.filteredData.length / this.pageSize);
    this.totalPages = Array.from({ length: pageCount }, (_, i) => i);
  }

  updatePaginatedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.filteredData.slice(start, end);
  }

  // goToPage(pageIndex: number): void {
  //   this.currentPage = pageIndex;
  //   this.updatePaginatedData();
  // }

  // prevPage(): void {
  //   if (this.currentPage > 0) {
  //     this.currentPage--;
  //     this.updatePaginatedData();
  //   }
  // }

  // nextPage(): void {
  //   if (this.currentPage < this.totalPages.length - 1) {
  //     this.currentPage++;
  //     this.updatePaginatedData();
  //   }
  // }

  // editAccess(accessId: string) {
  //   this.router.navigate([`/edit-access/${accessId}`]);
  // }
  
  // viewAccess(accessId: string): void {
  //   this.router.navigate(['/view-access/${accessId}']);
  // }


  editAccess(accessId: string, currentPage: number): void {
    this.router.navigate([`/edit-access/${accessId}`], { 
      queryParams: {
        page: currentPage,
        searchText: this.searchText,
        subscriptionFilter: this.subscriptionFilter,
        statusFilter: this.statusFilter
      }
    });
  }
  
  viewAccess(accessId: string, currentPage: number): void {
    this.router.navigate([`/edit-access/${accessId}`], { 
      queryParams: {
        page: currentPage,
        searchText: this.searchText,
        subscriptionFilter: this.subscriptionFilter,
        statusFilter: this.statusFilter
      }
    });
  }
  

  clear(){
    this.searchText = '';
    this.subscriptionFilter = '';
    this.statusFilter = '';

    // Show all access when cleared
    this.filteredData = [...this.access];
    this.pages = Math.ceil(this.filteredData.length / this.pageSize);
    this.totalAccess = this.filteredData.length;
    this.currentPage = 1;
    this.updatePageRange();
    this.updatePaginatedData();
  }

  disableAccess(id: number, isActive: boolean): void {
    console.log('Received ID:', id); // Debugging
    console.log('Received is_active:', isActive); // Debugging

    if (!id) {
        console.error('Access ID is undefined');
        return;
    }

    const payload = { is_active: isActive ? 1 : 0 };
    this.apiService.post(`api/deactivateUser/${id}`, payload).subscribe(
        (response) => {
            console.log('Access status updated:', response);
            this.loadAccess(); // Refresh the access list
        },
        (error) => {
            console.error('Error updating access status:', error);
            window.alert('Failed to update access status.');
        }
    );
}
 
toggleAccessStatus(access: Access): void {
  const newStatus = access.status === 'Active' ? 'inactive' : 'active'; // Ensure lowercase 'active'/'inactive'

  this.apiService.updateAccessStatus(access.id.toString(), newStatus).subscribe(
    response => {
      console.log('Access status updated successfully', response);
      // Update the access's status in the local array
      access.status = newStatus === 'active' ? 'Active' : 'Inactive'; // Update local status
      // Optionally, refresh the access list or update the UI
      this.loadAccess();
    },
    error => {
      console.error('Error updating access status', error);
      alert('Failed to update access status. Please try again.');
    }
  );
}

// === Modal Methods ===
openAddAccessModal(): void {
  const modal = new (window as any).bootstrap.Modal(document.getElementById('addAccessModal'));
  modal.show();
}

openEditAccessModal(access: Access): void {
  this.selectedAccessId = access.id;
  const modal = new (window as any).bootstrap.Modal(document.getElementById('editAccessModal'));
  modal.show();
}

onAccessAdded(): void {
  const modalEl = document.getElementById('addAccessModal');
  const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
  modal?.hide();
  this.loadAccess();
}

onAccessUpdated(): void {
  const modalEl = document.getElementById('editAccessModal');
  const modal = (window as any).bootstrap.Modal.getInstance(modalEl);
  modal?.hide();
  this.loadAccess();
}
}

